import config from '@/config';
import useCache from '@/hooks/useCache';
import useStateHandler from '@/hooks/useStateHandler';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

import './index.css';

export default function OrdersConfirmed() {
  const { state } = useStateHandler();
  const { loading, fetchData, setFetchData, loadMoreData } = useCache(`${state.user_session._id}_orders_confirmed`, `${config.apis.api.url}/orders/confirmed`, {
    injectToken: true,
    invalidateWhen: ["BUY_ARTWORK", "ORDER_MESSAGES_READ"],
    includeSearchQueries: { type: state.user_session.user_type === "gallery" ? "seller" : "buyer" }
  });

  if(loading) {
    return (
      <Loader />
    );
  }
  else if(fetchData.data.length === 0) {
    return (
      <Text className="orders-confirmed__empty-text" paragraph>There are no confirmed orders at the moment.
      </Text>
    );
  } else {
    return (
      <>
        <VirtualList
          fetchData={fetchData}
          setFetchData={setFetchData}
          loadMoreData={loadMoreData}
        />
      </>
    );
  }
}
